import { createContext, useContext, useEffect } from 'react';

/**
 * A panel that needs more room than its type gives (a form beside the week it
 * falls in) asks the slide-over to widen while it is shown: useWideSlideOver()
 * inside it. The portal provides the setter and narrows it back on unmount.
 */
export const WideSlideOverContext = createContext(() => {});

export const WIDE_SLIDE_OVER_WIDTH = 'lg:w-[min(1280px,calc(100vw_-_4rem))]';

const useWideSlideOver = (wide = true) => {
  const setWide = useContext(WideSlideOverContext);
  useEffect(() => {
    if (!wide) return undefined;
    setWide(true);
    return () => setWide(false);
  }, [setWide, wide]);
};

export default useWideSlideOver;
